// extracted by mini-css-extract-plugin
export default {"CreateAppeal__list":"CreateAppeal_CreateAppeal__list__QM7DF","CreateAppeal__item":"CreateAppeal_CreateAppeal__item__ASE5Z"};